var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Intro'),_c('ConferNote',{attrs:{"id":"confernote"}}),_c('Portfolios',{attrs:{"id":"portfolios"}}),_c('div',{staticClass:"padding"},[_c('Aboutus')],1),_c('Contactus')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }